import Vue from "vue";
import ContentNav from "../components/menuspy/MenuSpy.vue";

export default function() {
  const element = document.querySelector("#vue-menuspy");

  if (element) {
    let vueArgs = {};

    vueArgs = {...vueArgs, ...{
      el: element,

      components: {
        ContentNav
      },

      render: h => h(ContentNav)
    }};

    new Vue(vueArgs)
  }
}
